import React from 'react'
import { FormTextField, useZionFormContext, FormInputGroup } from '@fs/zion-form'
import { Cell, Grid, SubheaderBlock, useContainerWidth } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import FadeIn from './FadeIn'
import PlaceField from './PlaceField'

const keyMap = {
  yearLabel: {
    birth: 'ancestors.birth.range.label',
    death: 'ancestors.death.range.label',
  },
  heading: {
    birth: 'ancestors.birth.header',
    death: 'ancestors.death.header',
  },
}

export default function EventFields({ type }: { type: 'birth' | 'death' }): JSX.Element {
  const [t] = useTranslation()
  const atWidth = useContainerWidth()
  const { getValues, setValue } = useZionFormContext()
  const isMobile = atWidth({ default: true, md: false })
  const yearLabel = isMobile ? t('ancestors.year.range.condensed-label') : t(keyMap.yearLabel[type])

  // Following functions auto fill date inputs left blank in order to encourage more narrow search parameters.
  function handleFromBlur(): void {
    const [dateBegin, dateEnd] = getValues([`${type}_date_begin`, `${type}_date_end`])
    if (dateBegin && !dateEnd) {
      setValue(`${type}_date_end`, dateBegin)
    }
  }

  function handleToBlur(): void {
    const [dateBegin, dateEnd] = getValues([`${type}_date_begin`, `${type}_date_end`])
    if (dateEnd && !dateBegin) {
      setValue(`${type}_date_begin`, dateEnd)
    }
  }

  return (
    <FadeIn>
      <Grid guttersY="none">
        <Cell columns={isMobile ? 12 : 2} />
        <Cell columns={isMobile ? 12 : 4}>
          {isMobile && <SubheaderBlock size="sm" heading={t(keyMap.heading[type])} />}
          <PlaceField type={type} />
        </Cell>
        <FormInputGroup label={yearLabel} columns={isMobile ? 12 : 4}>
          <Grid>
            <FormTextField
              columns={isMobile ? 6 : 2}
              placeholder={t('ancestors.from.label')}
              name={`${type}_date_begin`}
              data-testid={`${type}-range-from`}
              onBlur={handleFromBlur}
            />
            <FormTextField
              columns={isMobile ? 6 : 2}
              placeholder={t('ancestors.to.label')}
              name={`${type}_date_end`}
              data-testid={`${type}-range-to`}
              onBlur={handleToBlur}
            />
          </Grid>
        </FormInputGroup>
      </Grid>
    </FadeIn>
  )
}
